import i from "./ghl-ui.es416.js";
import f from "./ghl-ui.es417.js";
import p from "./ghl-ui.es418.js";
import e from "./ghl-ui.es419.js";
import m from "./ghl-ui.es420.js";
import n from "./ghl-ui.es421.js";
import s from "./ghl-ui.es422.js";
import y from "./ghl-ui.es423.js";
var g = "[object Map]", c = "[object Set]", a = Object.prototype, b = a.hasOwnProperty;
function k(r) {
  if (r == null)
    return !0;
  if (m(r) && (e(r) || typeof r == "string" || typeof r.splice == "function" || n(r) || y(r) || p(r)))
    return !r.length;
  var t = f(r);
  if (t == g || t == c)
    return !r.size;
  if (s(r))
    return !i(r).length;
  for (var o in r)
    if (b.call(r, o))
      return !1;
  return !0;
}
export {
  k as default
};
